module.exports = __webpack_public_path__ + "static/Perkel_Resume_Actual-d70406f16b53fc012d185f8ec9011d3d.jpg";